import * as React from 'react';
import {CSSProperties} from 'react';
import * as Tgcc from '../tgccGlobal';
import {connect} from 'react-redux';
import Radium, { StyleRoot } from 'radium';
import {browserHistory} from 'react-router';
import { encodeColor } from '../tgccRequest';



const container : CSSProperties = {
    display:'flex',
    flexDirection:'row',
    flexFlow:'row wrap',
    justifyContent:'center',
    fontFamily:"AveriaSerifLight",
    width:'100%',
    marginBottom:'25px'
}
const div : CSSProperties = {
    width:'325px',
    padding:'15px',
    color:'rgb(97, 96, 96)',
    display:'flex',
    flexDirection:'column',
    alignItems:'center'
}

const text: CSSProperties = {
    fontSize:'19px',
    fontFamily:'AveriaSerifLightItalic',
    textAlign:'center',
    color:'black'
}

const rush: CSSProperties = {
    fontFamily:"AveriaSerifBoldItalic",
}
const whyGC: CSSProperties = {
    height:'50px',
    marginTop:'2%',
    display:'flex',
    flexDirection:'column',
    alignItems:'center',
    marginBottom:'15px'
}
const imgStyle: CSSProperties = {
    width:'200px',
}
const whyIndigo: CSSProperties = {
    display:'flex',
    flexDirection:'column',
    alignItems:'center'
}
class _WhyIndigo extends React.Component<Tgcc.BaseProps, any> {  

    render() {      
        return (
                <div className="whyUs" style={whyIndigo}>
                    <img style={whyGC} src={Tgcc.ResolveUrl('~/images/WhyIndigo.png')} className="whyImg"/>
                    <div style={container}>
                        <div style={div}>
                            <img style={imgStyle} src={Tgcc.ResolveUrl('~/images/IndigoTurn.png')} />
                            <div style={text}>Apparel delivered in as fast as 5-7 business days with rush options available.</div>
                        </div>
                        <div style={div}>
                            <img style={imgStyle} src={Tgcc.ResolveUrl('~/images/IndigoApparel.png')} />
                            <div style={text}>Featuring the trendiest high quality garments sure to become your best sellers.</div>
                        </div>
                        <div style={div}>
                            <img  style={imgStyle} src={Tgcc.ResolveUrl('~/images/IndigoArt.png')}/>
                            <div style={text}>Over 15k unique designs with new ones added daily.</div>
                        </div>   
                    </div>
                </div>   
        )
    }
}
const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return { state: state };
};

export var WhyIndigo = connect(mapStateToProps)(Radium(_WhyIndigo));
